module.exports = __webpack_public_path__ + "img/activecampaign_logo@3x.3d0204c8.png";